export default "__VITE_ASSET__e68b8f2d__"